module.exports = __webpack_public_path__ + "static/media/qr-code-apple-onboarding-prod.dd33c37e.png";